import React from 'react';
import { useTimer } from '../../hooks/useTimer';

export function CampaignOnInit({
	displayTimer,
	onMount,
	children,
}: {
	displayTimer: number | null;
	onMount: () => void;
	children: React.ReactElement;
}) {
	useTimer(onMount, displayTimer);

	return children;
}
